import React from "react";

const ASP_HOME = () => {
  return (
    <div className="tutorial-page">
      <h1>ASP HOME</h1>
      <p>This is the ASP HOME page content.</p>
    </div>
  );
};

export default ASP_HOME;
